if (!customElements.get("m-collection-header")) {
  class MCollectionHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // PERF: simple-parallax.min.js removed — parallax no longer loaded.
    }
  }
  customElements.define("m-collection-header", MCollectionHeader);
}
